function updateOverlayActiveSlides(track) {
  if (!track) return;

  const trackRect = track.getBoundingClientRect();
  const cards = track.querySelectorAll('.block-slide');

  cards.forEach(card => {
    const rect = card.getBoundingClientRect();
    const isPartiallyVisible =
      rect.right > trackRect.left && rect.left < trackRect.right;
    const isClipped =
      isPartiallyVisible &&
      (rect.left < trackRect.left - 1 || rect.right > trackRect.right + 1);

    card.classList.toggle('overlay-active', isClipped);
  });
}

function setActiveBlock(track) {
  track = track || document.querySelector('.block-slide-track');
  if (!track) return;

  const cards = track.querySelectorAll('.block-slide');
  const trackRect = track.getBoundingClientRect();
  const centerX = trackRect.left + trackRect.width / 2;

  let closestCard = null;
  let minDistance = Infinity;

  cards.forEach(card => {
    const rect = card.getBoundingClientRect();
    const cardCenter = rect.left + rect.width / 2;
    const distance = Math.abs(cardCenter - centerX);

    if (distance < minDistance) {
      minDistance = distance;
      closestCard = card;
    }
  });

  cards.forEach(card => {
    card.classList.toggle('active', card === closestCard);
  });

  updateOverlayActiveSlides(track);
}

function cloneInfiniteScrollBlock(times = 3) {
  const track = document.querySelector('.block-slide-track');
  const items = Array.from(track.children);

  for (let i = 0; i < times; i++) {
    items.forEach(item => {
      const clone = item.cloneNode(true);
      track.appendChild(clone);
    });
  }
}
cloneInfiniteScrollBlock(3);

function scrollToCenterBlock(card) {
  const track = document.querySelector('.block-slide-track');
  const trackRect = track.getBoundingClientRect();
  const cardRect = card.getBoundingClientRect();
  const offset = (cardRect.left + cardRect.width / 2) - (trackRect.left + trackRect.width / 2);
  track.scrollLeft += offset;
}
function scrollToAdjacentBlock(direction) {
  const cards = Array.from(document.querySelectorAll('.block-slide'));
  const track = document.querySelector('.block-slide-track');
  const trackRect = track.getBoundingClientRect();
  const centerX = trackRect.left + trackRect.width / 2;

  let closestCardIndex = -1;
  let minDistance = Infinity;

  cards.forEach((card, index) => {
    const rect = card.getBoundingClientRect();
    const cardCenter = rect.left + rect.width / 2;
    const distance = Math.abs(cardCenter - centerX);

    if (distance < minDistance) {
      minDistance = distance;
      closestCardIndex = index;
    }
  });

  let targetIndex = direction === 'left' ? closestCardIndex - 1 : closestCardIndex + 1;
  if (targetIndex < 0) targetIndex = 0;
  if (targetIndex >= cards.length) targetIndex = cards.length - 1;

  // Gán class active trước để có đúng width
  cards.forEach(card => {
    card.classList.remove('active');
  });
  cards[targetIndex].classList.add('active');

  // Đợi trình duyệt cập nhật layout rồi mới scroll
  setTimeout(() => {
    scrollToCenterBlock(cards[targetIndex]);
  }, 50);
}


document.addEventListener('DOMContentLoaded', () => {
  const track = document.querySelector('.block-slide-track');
  if (!track) return;

  const leftArrow = document.querySelector('.block-carousel-arrow-left');
  const rightArrow = document.querySelector('.block-carousel-arrow-right');
   setTimeout(() => {
    const blockCards = document.querySelectorAll('.block-slide');
    const middleCardIndex = Math.floor(blockCards.length / 2);
    const middleCard = blockCards[middleCardIndex];
  
    if (middleCard) {
      // Bỏ active cũ nếu có
      blockCards.forEach(card => card.classList.remove('active'));
  
      // Gán active để có width 368px trước khi scroll
      middleCard.classList.add('active');
  
      // Đợi layout cập nhật rồi mới scroll
      setTimeout(() => {
        scrollToCenterBlock(middleCard);
        updateOverlayActiveSlides(track);
      }, 50);
    }
  }, 200);


  leftArrow.addEventListener('click', () => {
    scrollToAdjacentBlock('left');
  });
  
  rightArrow.addEventListener('click', () => {
    scrollToAdjacentBlock('right');
  });


  // Scroll carousel
  track.addEventListener('scroll', () => {
    updateOverlayActiveSlides(track);

    if (track._scrollTimer) clearTimeout(track._scrollTimer);
    track._scrollTimer = setTimeout(() => setActiveBlock(track), 100);

    const scrollWidth = track.scrollWidth;
    const scrollLeft = track.scrollLeft;
    const clientWidth = track.clientWidth;

    // Reset về giữa nếu scroll gần cuối
    if (scrollLeft + clientWidth >= scrollWidth - 50) {
      track.scrollLeft = scrollWidth / 2 - clientWidth / 2;
    }
  });

  // Resize window
  window.addEventListener('resize', () => {
    setTimeout(() => setActiveBlock(track), 200);
  });
  // Click vào card
  document.querySelectorAll('.block-slide').forEach(card => {
    const moreInfoBtn = card.querySelector('.more-info-btn');
    const closeBtn = card.querySelector('.close-more-info');
    const front = card.querySelector('.block-slide-front');
    const back = card.querySelector('.block-slide-back');
    if (front) {
      front.addEventListener('click', function (e) {
        card.classList.add('flipped');
      });
    }

    if (back) {
      back.addEventListener('click', function (e) {
        card.classList.remove('flipped');
      });
    }
    
    if (moreInfoBtn) {
      moreInfoBtn.addEventListener('click', function (e) {
        card.classList.add('flipped');
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        card.classList.remove('flipped');
      });
    }
    card.addEventListener('click', (e) => {
      e.preventDefault();
  
      // Gán class active
      document.querySelectorAll('.block-slide').forEach(c => c.classList.remove('active'));
      card.classList.add('active');
  
      setTimeout(() => {
        scrollToCenterBlock(card);
      }, 50);
    });
  });
});
